import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";

export const useAddSeriesModalViewModel = ({
  accountId,
  setRefresh,
  handleCloseModal,
}) => {
  const [specLevelOptions, setSpecLevelOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [seriesGroupOptions, setSeriesGroupOptions] = useState([]);

  const debouncedSearch = useDebounce(search, 300);
  const stateManager = useComponentState();

  const getSpecLevelOptions = () => {
    stateManager.run(async () => {
      const response = await homeService.series.specLevel.getSuggestions({
        searchText: debouncedSearch,
        accountId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        const options = response.data.filter((item) => item);
        setSpecLevelOptions(options);
      }
    });
  };

  const getSeriesGroupOptions = () => {
    stateManager.run(async () => {
      const response = await homeService.seriesGroup.getAll({
        sort: "name",
        filters: {
          accountId: { type: "guid", value: accountId },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        const options = response.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setSeriesGroupOptions([{ label: "None", value: null }, ...options]);
      }
    });
  };

  const handleCreateSeries = (data) => {
    stateManager.run(async () => {
      const response = await homeService.series.create({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully created Series: ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        handleCloseModal();
        setRefresh((prev) => !prev);
      }
    });
  };

  const handleUpdateSeries = (data) => {
    stateManager.run(async () => {
      const response = await homeService.series.update({
        id: data.id,
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully updated Series: ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        handleCloseModal();
        setRefresh((prev) => !prev);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    debouncedSearch,
    specLevelOptions,
    seriesGroupOptions,
    getSeriesGroupOptions,
    setSearch,
    getSpecLevelOptions,
    handleCreateSeries,
    handleUpdateSeries,
  };
};
